const tooltips = {
  raktar: 'A rendszerben működő készlet modul alapja a raktár, készletmozgások, készletinformációk csak raktárhoz kapcsolódóan érhetőek el. Ezen raktárak kialakítására, karbantartására szolgál ez a felület. A felhasználók csak a hozzájuk rendelt raktárak kezelésére jogosultak, melyet szerepkörök felhasználóhoz rendelésével lehet szabályozni a rendszerben.\nRaktár nem rögzíthető cégadat kapcsolat nélkül, így kialakításuk előtt mindig rögzíteni kell a rendszerben kezelt cégek adatait. Egy céghez több raktár is rögzíthető.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
